<template>
  <div>
    <hr />
    <b-row>
      <b-col v-for="(panel, i) in content" :key="i" class="border">
        <div v-for="(widget, j) in panel.widgets" :key="j">
          <b-row align-h="between">
            <b-col>
              <b-badge variant="secondary">
                {{ widget.type.replace('_', ' ').toUpperCase() }}
              </b-badge>
            </b-col>
            <b-col cols="auto">
              <button v-b-modal="`remove-header-widget${i}${j}`" class="btn p-0" type="button">
                <i class="fa fa-times" />
              </button>

              <b-modal :id="`remove-header-widget${i}${j}`" title="Remove Header Widget" @ok="removeHeaderWidget(i)">
                Are you sure you want to remove widget from header?
              </b-modal>
            </b-col>
          </b-row>
          <hr class="mt-1" />

          <component
            :is="generateComponent(widget.type)"
            v-model="widget.content"
            :resolved="resolved ? resolved[i].resolved[j].resolved : null"
          />
        </div>
      </b-col>
    </b-row>

    <hr />
    <b-row align-v="center">
      <b-col cols="auto">
        <b-form-select v-model="selectedPanel" :options="headerPanels" />
      </b-col>
      <b-col>
        <pages-widget-picker
          id="tooltip-target-1"
          button-text="Add Header Widget"
          :allow="['text', 'image']"
          :disabled="selectedPanelDisabled"
          @widget="widget => addHeaderWidget(widget)"
        />

        <b-tooltip target="tooltip-target-1" triggers="hover" :disabled="!selectedPanelDisabled">
          Only one of the whitelisted widgets is allowed in {{ selectedPanel.replace('_', ' ') }}
        </b-tooltip>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import PagesWidgetPicker from '../PagesWidgetPicker'
import PagesTextWidget from './PagesTextWidget'
import PagesImageWidget from './PagesImageWidget'

export default {
  name: 'PagesHeaderWidget',
  components: { PagesWidgetPicker, PagesTextWidget, PagesImageWidget },
  props: { value: { type: Array }, resolved: { type: Array } },
  data() {
    return {
      content: this.value,
      selectedPanel: 'left_panel',
      headerPanels: [
        { value: 'left_panel', text: 'Left Panel' },
        { value: 'right_panel', text: 'Right Panel' },
      ],
    }
  },
  computed: {
    selectedPanelDisabled() {
      return this.content.find(content => content.type === this.selectedPanel)?.content?.length > 0
    },
  },
  methods: {
    addHeaderWidget(data) {
      const index = this.content.findIndex(content => content.type === this.selectedPanel)
      this.content[index].widgets.push(data)
    },
    generateComponent(type) {
      const component = type
        .split('_')
        .map(c => c.charAt(0).toUpperCase() + c.slice(1))
        .join('')

      return `Pages${component}Widget`
    },
    removeHeaderWidget(panel) {
      this.content[panel].widgets.splice(0, 1)
    },
  },
}
</script>
